module.exports = __webpack_public_path__ + "static/media/poltekbang.eb8a129c.png";